import React from 'react'
import NextLink from 'next/link'
import { default as MUILink, LinkProps } from '@mui/material/Link'

type Props = Omit<LinkProps, 'href'> & { href: string; forceExternal?: boolean }

const NextMuiLink: React.FC<Props> = ({ href = '', forceExternal = false, ...muiLinkProps }) => {
  if (!href.length || href === '#') {
    return null
  }

  let targetProps = {}
  if (forceExternal || href?.startsWith('http')) {
    targetProps = { target: '_blank', rel: 'noopener noreferrer' }

    return <MUILink href={href} {...targetProps} {...muiLinkProps} />
  }

  return (
    <NextLink legacyBehavior href={href} passHref>
      <MUILink {...muiLinkProps} />
    </NextLink>
  )
}

export default NextMuiLink
